/* eslint-disable no-useless-escape */
/* eslint-disable no-undef */
/* eslint-disable require-jsdoc */

'use strict';

/** NB Customization Reason:
 *  This file does not exist in the link_adyen cartiridge and is added to make the
 *  adyen component UI look correct and as intended on the New Balance site.
 */

function getCardStyleConfig() {
    return {
        base: {
            fontFamily: 'Proxima Nova W01,-apple-system,BlinkMacSystemFont,Helvetica Neue,Helvetica,Arial,sans-serif',
            fontSize: '14px',
            fontWeight: '500'
        },
        placeholder: {
            color: '#767676',
            fontWeight: '300',
            fontSize: '14px'
        }
    };
}

function getBrandConfig() {
    return {
        amex: {
            icon: window.staticImageURL + 'images/amex.png'
        }
    };
}

function getCardTranslations() {
    var translations = {};
    if (window.Configuration && window.Configuration.locale) {
        var locale = (window.Configuration.locale).replace('_', '-');
        translations[locale] = window.adyenTranslations;
    }
    return translations;
}

function cardHolderNameEvents() {
    var $holderNameInput = $('.adyen-checkout__card__holderName__input');
    var regexText = $('button[value="add-new-payment"]').attr('data-holdernameregex');
    var regexData = new RegExp(regexText, 'gi');

    $holderNameInput.attr('maxlength', '60');

    $holderNameInput.on('keyup keypress keydown', function (e) {
        var code = String.fromCharCode(e.keyCode || e.which || e.charCode);

        if (code && regexData.test(code)) {
            e.preventDefault();
            return false;
        }

        return true;
    });

    $holderNameInput.on('paste', function (e) {
        e.preventDefault();

        var originalText = '';
        if (e.clipboardData || e.originalEvent.clipboardData) {
            originalText = (e.originalEvent || e).clipboardData.getData('text/plain');
        } else if (window.clipboardData) {
            originalText = window.clipboardData.getData('Text');
        }

        var cleanedText = originalText.replace(regexData, '');
        if (document.queryCommandSupported('insertText')) {
            document.execCommand('insertText', false, cleanedText);
        } else {
            document.execCommand('paste', false, cleanedText);
        }
    });
}

function modifyAdyenFormElements() {
    // Observe payment method list
    var paymentMethodList = $('#paymentMethodsList');
    if (paymentMethodList.length) {
        var mutationHandler = function (mutationList) {
            var keys = Object.keys(mutationList);
            keys.forEach(function (val) {
                var mutation = mutationList[val];
                if (mutation.type === 'childList') {
                    var addedNodes = mutation && mutation.addedNodes;
                    if (addedNodes.length && $(addedNodes).find('.paymentMethod_img').length) {
                        $('.paymentMethod_img').attr('alt', '');
                        observer.disconnect(); // eslint-disable-line
                    }
                }
            });
        };
        var config = { attributes: true, childList: true, subtree: true };
        var observer = new MutationObserver(mutationHandler);
        observer.observe(paymentMethodList[0], config);
    }
}

function initEvents() {
    cardHolderNameEvents();
    modifyAdyenFormElements();
}

module.exports = {
    getCardStyleConfig: getCardStyleConfig,
    getBrandConfig: getBrandConfig,
    getCardTranslations: getCardTranslations,
    initEvents: initEvents
};
